export default __webpack_public_path__ + "media/zurb/img/home/home-tool-foundation-c173f2492fe87dc063b5d587a28a4b59.png";